import apiClient from './config';

const token = localStorage.getItem('token');
const headers = token ? { 'Authorization': token } : {};

const checkinApi = {
  // Check in
  checkin: async (checkinData) => {
    try {
      const response = await apiClient.post(
        '/order-checkin',
        checkinData, // ✅ body
        token ? { headers } : {} // ✅ only include headers if token exists
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check out
  checkout: async (checkoutData) => {
    try {
      const response = await apiClient.put('/order-checkout-customer', checkoutData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get checkin history
  getCheckinHistory: async (params = {}) => {
    try {
      const response = await apiClient.get('/checkin/history', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default checkinApi; 